<script setup lang="ts">
import { Method } from '~/enums';
import { useEquipStore } from '~/store/equipStore';

const equipStore = useEquipStore();

const props = defineProps<{
	specData: any
	engSource?: string,
	specInfoType?: string,
}>()

const specInfo = computed(() => props.specData);


</script>

<template>
	<div class="content">
		<div class="wrapper" v-if="specInfo">
			<template v-if="props.engSource === '10'">
				<div class="content-wrapper">
					<span class="first_letter">설치유형</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleInstallTypeName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">모듈결정분류</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleTypeName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">모듈당 용량(W)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleCapacity) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">모듈 총 용량(kW)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleTotalCapacity) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">모듈 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">모듈 모델명</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">모듈 방위각</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleAzimuth) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">모듈 경사각</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleAngle) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">모듈 직렬개수</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleSerialCnt) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">모듈 병렬개수</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.moduleParallelCnt) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">인버터 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.pviCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">인버터 모델명</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.pviModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">인버터 용량(kW)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.pviCapacity) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">위상종류</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.pviPhaseName) }}</span>
				</div>
			</template>
			<template v-else-if="props.engSource === '20'">
				<div class="content-wrapper">
					<span class="first_letter">현재 사용 열원</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.usageEngSource) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">집열기 설치 방식</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.collectorInstallTypeName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">집열기 종류</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.collectorKindName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">집열기 면적</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.collectorArea) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">집열기 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.collectorCompany) }}</span>
				</div>

				<div class="content-wrapper">
					<span class="first_letter">집열기 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.collectorModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">집열기 직렬개수</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.collectorSerialCnt) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">집열기 병렬개수</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.collectorParallelCnt) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">집열기 매수</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.collectorCnt) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">차온제어기 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.controllerCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">차온제어기 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.controllerModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">부하측 열량계 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hMeterCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">부하측 열량계 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hMeterModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">방위각</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.azimuth) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">경사각</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.angle) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">열매체 펌프 유형</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hpumpType) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">열매체 펌프 유량(LPM)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hpumpFlow) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">열매체 펌프 양정(m)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hpumpHead) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">열매체 보충 펌프 유형</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hSubpumpType) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">열매체 보충 펌프 유량(LPM)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hSubpumpFlow) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">열매체 보충 펌프 양정(m)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hSubpumpHead) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">온수 순환 펌프 유형</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.circulatorpumpType) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">온수 순환 펌프 유량(LPM)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.circulatorpumpFlow) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">온수 순환 펌프 양정(m)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.circulatorpumpHead) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">유석(m/s)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.flowSpeed) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">운전압력(bar)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.opPressure) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">배관관경(A)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.pipeDiameter) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">축열탱크 용량(L)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.storageCapacity) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">축열탱크 재질</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.storageMaterial) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">보증 기간</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.warranty) }}</span>
				</div>
			</template>
			<template v-else-if="props.engSource === '30'">
				<template v-if="props.specInfoType === 'drgeo'">
				<div class="content-wrapper">
					<span class="first_letter">주소</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.equipAddr) }} {{ commonUtils.isAllStrDataEmpty(specInfo.equipDetailAddr) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">시스템 방식</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.geoSysTypeName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">시스템 구분</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.geoSysKindName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">히트펌프 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hpCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">히트펌프 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hpModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">히트펌프 용량</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hpCapacity) }}kW</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">냉/난방 정미능력</span>
					<span>{{ `
						${commonUtils.isAllStrDataEmpty(specInfo.coolCapacity, 3)}kW /  
					${commonUtils.isAllStrDataEmpty(specInfo.heatCapacity, 3)}kW
					` }}</span>
				</div>

				<div class="content-wrapper">
					<span class="first_letter">냉/난방 유효전력</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.coolActivePower, 3) }}kW / {{ commonUtils.isAllStrDataEmpty(specInfo.heatActivePower, 3) }} kW</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">냉/난방 정격전류</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.coolRatedCurrent) }}A / {{ commonUtils.isAllStrDataEmpty(specInfo.heatRatedCurrent) }}A</span>
				</div>

				<div class="content-wrapper">
					<span class="first_letter">순환펌프 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.cpCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">순환펌프 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.cpModelName) }}</span>
				</div>
				<!-- <div class="content-wrapper">
					<span class="first_letter">순환펌프 설치개수</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.cpCount) }}개</span>
				</div> -->
				<div class="content-wrapper">
					<span class="first_letter">순환펌프 용량</span>
					<span>{{ `${commonUtils.isAllStrDataEmpty(specInfo.cpCapacity)}kW (${commonUtils.isAllStrDataEmpty(specInfo.cpCount)}대)` }}</span>
				</div>
				<!-- <div class="content-wrapper">
					<span class="first_letter">양정(m)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.cpPumpUpHead) }}m</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">정격출력(kW)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.cpRatedPower, 2) }}kW</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">효율(%)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.cpEfficiency) }}%</span>
				</div> -->

				</template>
				<template v-else>
					<div class="content-wrapper">
					<span class="first_letter">시스템방식</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.geoSysTypeName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">시스템구분</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.geoSysKindName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">히트펌프용량(kW)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hpCapacity) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">히트펌프 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hpCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">히트펌프 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hpModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">급탕 열량계 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hwMeterCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">급탕 열량계 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hwMeterModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">냉난방측 열량계 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hcMeterCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">냉난방측 열량계 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.hcMeterModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">전력량계 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.KWHCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">전력량계 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.KWHModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">벤토나이트 제조사</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.bentoniteCompany) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">벤토나이트 모델</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.bentoniteModelName) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">냉온수 유량(LPM)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.chWaterFlow) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">지열수 유량(LPM)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.geoWaterFLow) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">천공깊이(m)</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.boringDeep) }}</span>
				</div>
				<div class="content-wrapper">
					<span class="first_letter">천공개수</span>
					<span>{{ commonUtils.isAllStrDataEmpty(specInfo.boringCount) }}</span>
				</div>
				</template>
			
			</template>
		</div>
			<div class="spec-no-data" v-else>제원정보가 존재하지 않습니다.</div>

	</div>

</template>

<style lang="scss" scoped>
@import "@/assets/styles/design-toc/in-equip-card.scss";
</style>